module.exports = __webpack_public_path__ + "assets/img/block-right-hover-f20ada6d.png";